import l from "components/util/l";

const ENVIRONMENT_LABELS = {
  PROD: l("Producción%EN015"),
  DEV: l("Desarrollo%PA481"),
  TEST: l("Pruebas%EN016"),
};

// Environments arrive from GraphQL as camelCase and from the REST endpoints as snake_case.
export const environmentLabel = (item) =>
  ENVIRONMENT_LABELS[item.environment] || item.environmentName || item.environment_name
  || l("Personalizado%EN017");
